// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width: 768px){.em-page-gradient{min-height:160px;background-image:linear-gradient(135deg, rgba(7, 138, 127, 0) 25%, rgb(7, 138, 127) 60%, rgba(7, 138, 127, 0) 60%),linear-gradient(-135deg, #017a71 0%, #00857a 100%);background-size:600px 160px,100% 160px;background-repeat:no-repeat;background-position:top}}", ""]);
// Exports
module.exports = exports;
